import { useQuery } from '@tanstack/react-query';
import { useEffect, type ReactNode } from 'react';
import { api } from '@/lib/api';
import { applyDesignToDocument, normalizeDesignPayload } from '@/lib/design';

type DesignProviderProps = {
  children: ReactNode;
  /** Черновик из админки (preview) */
  previewSettings?: Record<string, string> | null;
};

export function DesignProvider({ children, previewSettings }: DesignProviderProps) {
  const { data } = useQuery({
    queryKey: ['public-design'],
    queryFn: () => api.design(),
    staleTime: 60_000,
  });

  useEffect(() => {
    const published = normalizeDesignPayload(data || {});
    const merged = previewSettings ? { ...published, ...previewSettings } : published;
    applyDesignToDocument(merged);
  }, [data, previewSettings]);

  return <>{children}</>;
}
